/**
 * dateFmt — v2.69
 * Shared timestamp formatting utilities. All HouseEntry timestamps are
 * stored in DB as ISO-8601 UTC strings (with `+00:00` suffix). These
 * helpers parse + render in the user's local timezone consistently and
 * fail gracefully on null / invalid input.
 *
 * Why this exists:
 * `LeadsCRMTab.jsx` historically did `created_at.slice(11, 16)` to
 * extract HH:MM, which yielded raw UTC text — appearing 5.5 hours behind
 * for India users. Centralising format logic prevents that class of bug
 * from re-appearing whenever a new timestamp surface is added.
 */

const _safeDate = (ts) => {
  if (!ts) return null;
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const formatDate = (ts, fallback = "—") => {
  const d = _safeDate(ts);
  if (!d) return fallback;
  return d.toLocaleDateString();
};

export const formatTime = (ts, fallback = "—") => {
  const d = _safeDate(ts);
  if (!d) return fallback;
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const formatDateTime = (ts, fallback = "—") => {
  const d = _safeDate(ts);
  if (!d) return fallback;
  return d.toLocaleString();
};
